import type { ListCharterPricingInventoryParams } from '~/types/charterPricingInventory';

export const charterPricingInventoryQueryKeys = {
  all: ['flights-charter', 'fnf-fares'] as const,
  lists: () => [...charterPricingInventoryQueryKeys.all, 'list'] as const,
  list: (filters?: ListCharterPricingInventoryParams) =>
    [...charterPricingInventoryQueryKeys.lists(), filters] as const,
};
